//
//
//
//
//
//

import index from './index';
export default {
  name: 'InfoBasic',
  components: {
    index: index
  }
};